import Vue from "vue";
import { mapState, mapActions } from "vuex";

export default Vue.extend({
  computed: {
    ...mapState({ detail: state => state.order.detail })
  },
  created() {
    this.fetchDetail();
  },
  methods: {
    ...mapActions(["fetchOrderDetail"]),
    fetchDetail() {
      this.fetchOrderDetail(this);
    }
  }
});
